import { type AppConfigJson } from './backendConfigJsonSchema';

export const localhostDefaultConfig: AppConfigJson = {
  // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
  VivaPlanungBackendUrl: import.meta.env.VITE_VIVA_PLANUNG_BACKEND_URL ?? 'http://localhost:4444/api/',
  SapAdapterFrontendUrl: 'https://viva.vamos.ban.akadev.de', // legacy app main URL, since it's not necessary to point to a locally running instance
  // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
  AzureAdClientId: import.meta.env.VITE_APP_AZURE_AD_CLIENT_ID ?? '77c77ea6-1f7d-470c-85eb-10fdf813846e',
  // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
  AzureAdTenantId: import.meta.env.VITE_APP_AZURE_AD_TENANT_ID ?? '88d0a5a9-d61a-4dd6-9a75-6637f3fe6bd8',
  // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
  AzureAdRedirectUri: import.meta.env.VITE_APP_AZURE_AD_REDIRECT_URI ?? 'https://va.vamos.ban.akadev.de/auth/redirect',
  HiveAppUrl: 'https://hive.prml.ban.akadev.de',
  AusschreibungsportalUrl: 'https://ma-test.ausschreibungen.prml.ban.akadev.de',
  TaskManagementBoardUrl: 'https://jira.haufe.io/secure/RapidBoard.jspa?rapidView=2474',
  Stage: 'local',
};
